import { useNavigate } from "react-router-dom";
import useRedirect from "@/hooks/useRedirect";
import useCybersourceService from "@/hooks/useCybersourceService";
import { useEffect } from "react";
import useCheckoutCardForm from "../hooks/useCheckoutCardForm";
import CheckoutCardView from "./view";

export default function CheckoutCard() {
  useRedirect("checkout/card");
  const navigate = useNavigate();
  const { addCyberSourceScripts } = useCybersourceService();

  const {
    isLoading,
    isDisabled,
    errorType,
    dismissError,
    register,
    handleSubmit,
    errors,
    setValue,
    watch,
    trigger,
    clearErrors,
  } = useCheckoutCardForm({ navigate });

  const goBack = () => navigate(-1);

  useEffect(() => {
    addCyberSourceScripts();
  }, []);

  return (
    <CheckoutCardView
      register={register}
      handleSubmit={handleSubmit}
      errors={errors}
      goBack={goBack}
      isDisabled={isDisabled}
      errorType={errorType}
      dismissError={dismissError}
      isLoading={isLoading}
      setValue={setValue}
      watch={watch}
      trigger={trigger}
      clearErrors={clearErrors}
    />
  );
}